export default __webpack_public_path__ + "static/media/mustafa-resume.b938e683.pdf";